import axios from 'axios';
import { mockProjectApi, mockAuditApi } from '../mocks/mockApi';

const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Real Project API
const realProjectApi = {
    listProjects: () => api.get('/projects'),
    getProject: (name) => api.get(`/projects/${encodeURIComponent(name)}`),
    createProject: (project) => api.post('/projects', project),
    updateProject: (name, updates) => api.put(`/projects/${encodeURIComponent(name)}`, updates),
    deleteProject: (name, deleteData = false) => api.delete(`/projects/${encodeURIComponent(name)}`, { params: { deleteData } }),
    startConsumer: (name) => api.post(`/projects/${encodeURIComponent(name)}/start`),
    stopConsumer: (name) => api.post(`/projects/${encodeURIComponent(name)}/stop`),
    getStatus: (name) => api.get(`/projects/${encodeURIComponent(name)}/status`),
    deployConnector: (name) => api.post(`/projects/${encodeURIComponent(name)}/debezium`),
    removeConnector: (name) => api.delete(`/projects/${encodeURIComponent(name)}/debezium`),
    getProjectOperations: (name, page = 0, size = 20) => api.get(`/projects/${encodeURIComponent(name)}/operations`, { params: { page, size } }),
    getAllOperations: (page = 0, size = 20) => api.get('/projects/operations', { params: { page, size } }),
};

// Real Audit API
const realAuditApi = {
    queryTransactions: (params = {}) => api.get('/audit/transactions', { params }),
    getTransactionDetail: (transactionId) => api.get(`/audit/transactions/${encodeURIComponent(transactionId)}`),
    getRecordHistory: (recordIdentifier) => api.get(`/audit/records/${encodeURIComponent(recordIdentifier)}/history`),
    getStats: (projectId) => api.get('/audit/stats', { params: projectId ? { projectId } : {} }),
    search: (query, projectId, page = 0, size = 20) => api.get('/audit/search', { params: { q: query, projectId, page, size } }),
    health: () => api.get('/audit/health'),
    suggestUserIds: (q, limit = 10) => api.get('/audit/suggest-userids', { params: { q, limit } }),
    suggestTableNames: (q, limit = 10) => api.get('/audit/suggest-tables', { params: { q, limit } }),
};

// Health API
export const healthApi = {
    getGlobalHealth: () => api.get('/health'),
    getProjectHealth: (name) => api.get(`/health/${encodeURIComponent(name)}`),
    getComponents: () => api.get('/health/components'),
};

// Export based on mock toggle
export const projectApi = USE_MOCK ? mockProjectApi : realProjectApi;
export const auditApi = USE_MOCK ? mockAuditApi : realAuditApi;

if (USE_MOCK) {
    console.log('[API] Using mock data layer');
}

export default api;
